export class LoadDashboard {
  static readonly type = '[Dashboard] Load';
}

export class SetSelectedBranches {
  static readonly type = '[Dashboard] Set Selected Branches';
  constructor(public branchIds: string[]) {}
}

// ─── Per-widget sub-actions ─────────────────────────────────────

export class LoadOrderStats {
  static readonly type = '[Dashboard] Load Order Stats';
}

export class LoadShifts {
  static readonly type = '[Dashboard] Load Shifts';
}

export class LoadLowStock {
  static readonly type = '[Dashboard] Load Low Stock';
}

export class LoadExpiringSoon {
  static readonly type = '[Dashboard] Load Expiring Soon';
}

export class LoadOutOfStock {
  static readonly type = '[Dashboard] Load Out Of Stock';
}

export class LoadTopProducts {
  static readonly type = '[Dashboard] Load Top Products';
}

export class LoadSuperintendentStatus {
  static readonly type = '[Dashboard] Load Superintendent Status';
}

export class LoadUsersExpiringCredentials {
  static readonly type = '[Dashboard] Load Users Expiring Credentials';
}

export class LoadCustomerStats {
  static readonly type = '[Dashboard] Load Customer Stats';
}
